import * as React from "react";
import classNames from "classnames";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { PropTypes } from "components/controls";

export interface AlertProps {
    color?: PropTypes.Color;
}


class Alert extends React.PureComponent<AlertProps & WithStyles<typeof styles>>{

    render() {
        const { color, classes, children } = this.props;
        const rootClass = classNames([
            { [classes.root]: true },
            { [classes.colorPrimary]: color === 'primary' },
            { [classes.colorSecondary]: color === 'secondary' },
            { [classes.colorSuccess]: color === 'success' },

            { [classes.colorInfo]: color === 'info' },
            { [classes.colorWarning]: color === 'warning' },
            { [classes.colorDanger]: color === 'danger' },

        ]);
        return <div className={rootClass}>{children}</div>;
    }
}


const styles = (theme: Theme) => createStyles({
    root: {
        padding: theme.spacing.unit * 2,
        border: '1px solid transparent',
        borderRadius: 4,
    },
    colorPrimary: {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
    },
    colorSecondary: {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.main,
    },
    colorSuccess: {
        //color: theme.palette.success.contrastText,
        //backgroundColor: theme.palette.success.main,
        color: '#3c763d',
        backgroundColor: '#dff0d8',
        borderColor: '#d6e9c6'
    },
    colorInfo: {
        //color: theme.palette.info.contrastText,
        //backgroundColor: theme.palette.info.main,
        color: '#31708f',
        backgroundColor: '#d9edf7',
        borderColor: '#bce8f1'
    },
    colorWarning: {
        //color: theme.palette.warning.contrastText,
        //backgroundColor: theme.palette.warning.main,
        backgroundColor: '#fcf8e3',
        borderColor: '#faebcc',
        color: '#8a6d3b',
    },

    colorDanger: {
        // color: theme.palette.danger.contrastText,
        // backgroundColor: theme.palette.danger.main,
        backgroundColor: '#f2dede',
        borderColor: '#ebccd1',
        color: '#a94442',
    }
});

export default withStyles(styles)(Alert);